module.exports = __webpack_public_path__ + "img/style_0_5.6a7e087f.png";